// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","styledPageHeader":"page-header_styledPageHeader__tYx4D","title":"page-header_title__CAPvL","text":"page-header_text__0bPPy"};